import _ from "lodash";

function ensureAbsolute(path) {
  return path[0] === "/" ? path : "/" + path;
}

export function getPathComponent(location, index) {
  const components = ensureAbsolute(location.pathname).split("/");
  return components[index < 0 ? components.length + index : index];
}

export function getPathPrefix(location, index) {
  const components = ensureAbsolute(location.pathname).split("/");
  return components.slice(0, index + 1).join("/");
}

export function pushComponent(location, value) {
  return ensureAbsolute(location.pathname + "/" + value);
}

export function popComponent(location) {
  const path = location.pathname;
  return ensureAbsolute(path.substring(0, path.lastIndexOf("/")));
}

export function popAndReplaceComponent(location, index, value) {
  const components = location.pathname.split("/").slice(0, index);
  if (!_.last(components)) {
    components.pop();
  }
  if (value) {
    components.push(value);
  }
  return components.join("/");
}

export function findPathComponent(location, value) {
  const components = ensureAbsolute(location.pathname).split("/");
  return components.indexOf(value);
}
